module.exports = __webpack_public_path__ + "img/eminal_logo.f64c4f9c.svg";